export default __webpack_public_path__ + "static/media/NoirPro-Light.0c5156a6.eot";